import { Center, type CenterProps, Loader } from "@mantine/core"

export function AppLoader(props: CenterProps) {
  return (
    <Center h="100%" w="100%" {...props}>
      <Loader color="cyan" m="xl" />
    </Center>
  )
}
